import React from 'react';
import StatusPill, { PillTone } from '../../components/StatusPill';
import { CorBand } from './config';

// The COR enums in the pill's vocabulary. Shared by the table cells and the
// detail-modal header so the two cannot drift.
const tone: Record<string, PillTone> = {
  // status
  Open: 'warning',
  'In Progress': 'info',
  Monitoring: 'complete',
  Closed: 'neutral',
  // type
  Change: 'info',
  Opportunity: 'success',
  Risk: 'danger',
};

/** Status / type enum value → status pill (shared by table + modal header). */
export const badge = (value: string | null | undefined): React.ReactElement => {
  if (!value) return <span className="text-muted">—</span>;
  return <StatusPill label={value} tone={tone[value] ?? 'neutral'} />;
};

/** Risk-rating band badge (LOW/MEDIUM/MEDIUM-HIGH/HIGH), optionally with the score. */
export const ratingBadge = (band: CorBand | null | undefined, score?: number | null): React.ReactElement => {
  if (!band) return <span className="text-muted">—</span>;
  const slug = band.toLowerCase().replace(/\s+/g, '-');
  const label = band === 'MEDIUM-HIGH' ? 'MED-HIGH' : band; // keep the table column compact
  return (
    <span className={`cor-band cor-band-${slug}`}>
      {label}{score != null ? ` (${score})` : ''}
    </span>
  );
};
